import { Application } from "@hotwired/stimulus"
import { registerControllers } from 'stimulus-vite-helpers'

const application = Application.start()
const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(application, controllers)

function registerPhlexControllers() {
  const controllers = import.meta.glob(
    [
      "./../../views/**/controller.js",
      "./../../../packages/**/app/views/**/controller.js"
    ],
    { eager: true }
  )

  for (let path in controllers) {
    let module = controllers[path]

    const match = path.match(/views\/(.+)\/controller\.js$/)[1]

    let name = match
      .replaceAll("components/", "")
      .replaceAll("_", "-")
      .replaceAll("/", "--")

    application.register(name, module.Controller)
  }
}

registerPhlexControllers()

import Clipboard from "@stimulus-components/clipboard"
application.register("clipboard", Clipboard)

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
